import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddVertical from "./AddVertical";
import { toast } from "react-toastify";

export interface AddVerticalInterface {
  _id: number;
  title: string;
  image: string;
}

export enum VerticalsStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

const columns = [
  {
    id: "image",
    label: "Image",
    minWidth: 170,
    // sortable: true,
  },
  {
    id: "title",
    label: "Our Verticals",
    minWidth: 170,
    // sortable: true,
  },
  {
    id: "createdAt",
    label: "Created Date",
    minWidth: 170,
    // sortable: true,
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center" as const,
  },
];

const Verticals = () => {
  const [showAdminBlade, setShowAdminBlade] = useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const searchRef = useRef<string>("");
  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
  const [loading, setLoading] = useState<boolean>(false);
  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    title: "title",
  };
  const [userObject, setUserObject] = useState<AddVerticalInterface | null>(
    null
  );
  const userInfo = JSON.parse(localStorage.getItem("UserData") || "{}");
    const [pagePermission, setPagePermission] = useState({
      canView: false,
      canAdd: false,
      canEdit: false,
      canDelete: false,
    });

  useEffect(() => {
    getVerticalList(searchRef.current);
  }, [currentPage, sortField, sortOrder]);

  const getVerticalList = (keyword: string = "") => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());

    // Keyword search
    if (keyword.trim()) {
      params.append("keyword", keyword.trim());
    }

    // Sorting
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    WebService.getAPI({
      action: `vertical/vertical-list?${params.toString()}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};

        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const formattedRows = res?.data?.data.map((item: any) => {
          return {
            ...item,
            image: (
              <img
                src={item.image}
                alt="vertical"
                style={{
                  width: "80px",
                  height: "50px",
                  objectFit: "cover",
                  borderRadius: 6,
                }}
              />
            ),

            title: item.title || "-",
            // phone: item.phone || "-",
            createdAt: HelperService.getFormatedDate(item.createdAt),
            action: actionList(item, perm),
          };
        });
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => {
        console.error("Error fetching vertical", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleReorder = (newRows: any) => {
    setLeadershipCouncils(newRows);

    const reorderedPayload = newRows.map((item: any, index: number) => ({
      _id: item._id,
      order_by: index + 1,
    }));

    WebService.postAPI({
      action: "vertical/update-order",
      body: reorderedPayload,
    })
      .then(() => {
        toast.success("Order updated successfully");
      })
      .catch(() => {
        toast.error("Failed to update order");
      });
  };

  const handleDeleteEvent = (leadershipCouncilId: string) => {
    setLeadershipCouncilToDelete(leadershipCouncilId);
    setShowDeleteModal(true);
  };

  const actionList = (item: any, perm: any) => {
    if (item._id === userInfo.id) {
      return null;
    }
    return (
      <div>
        {" "}
        { perm.canEdit && (

       
        <PencilFill
          className="me-3 cursor-pointer"
          onClick={() => {
            setShowAdminBlade(true);
            setUserObject(item);
          }}
          title="Edit"
        />  )}
            { perm.canDelete && (
        <TrashFill
          color="#DC143C"
          className="cursor-pointer"
          onClick={() => handleDeleteEvent(item._id)}
          title="Delete"
        /> )}
      </div>
    );
  };

  return (
    <>
      <AddVertical
        show={showAdminBlade}
        handleClose={() => {
          setShowAdminBlade(false);
          getVerticalList(searchRef.current);
          setUserObject(null);
        }}
        data={userObject}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.deleteAPI({
              action: `vertical/delete/${leadershipCouncilToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              toast.success("Vertical deleted successfully.");
              getVerticalList(searchRef.current);
            });
          }
        }}
        message="Are you sure you want to delete ?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Verticals</div>
     { pagePermission.canAdd && (
            <CustomButton
              isLoading={false}
              label="Add"
              onClick={() => {
                setShowAdminBlade(true);
                setUserObject(null);
              }}
              style={{ width: 100 }}
            /> )}
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  searchRef.current = value;                  
                  setSearch(value);
                  setCurrentPage(1);
                  getVerticalList(searchRef.current);
                }}
              />
            </div>
          </div>
          <CustomTableSortable
            columns={columns}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            isLoading={loading}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              setUiSortField(columnId);
              setSortOrder(order);
              const apiField = sortFieldMap[columnId] || "createdAt";
              setSortField(apiField);
              setCurrentPage(1);
              // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
            }}
            draggable // 👈 enable drag
            onRowsReorder={handleReorder} // 👈 handle dropping
          />
        </Card>
      </div>
    </>
  );
};

export default Verticals;
